<template>
  <v-dialog
    max-width="max-content"
    v-model="dialog"
    content-class="rounded-20"
    :persistent="loading"
  >
    <v-card>
      <v-card-title class="title-font font-weight-bold mb-2">
        {{ suggesting ? "Upgrade" : "Change" }} your subscription?
        <v-progress-circular
          indeterminate
          size="32"
          class="ml-5"
          v-if="loading"
        />
        <v-spacer />
        <v-btn icon @click="dialog = false" :disabled="loading">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-subtitle v-if="subscriptionSchedule" class="pt-2">
        <p v-if="!currentTenant.activated" class="black--text text-body-2 pt-2">
          <strong> This action will activate your Subscription. </strong>
        </p>

        Changing your subscription will cancel your currently scheduled
        {{
          isUpgrade(
            plans.find((p) => subscriptionSchedule === p.code)
          ).toLowerCase()
        }}.
      </v-card-subtitle>
      <v-card-text>
        <v-row> </v-row>
        <v-row justify="center">
          <v-col v-for="(pricing, index) in filteredPlans" :key="index">
            <PricingCard
              :pricing="pricing"
              :change="isUpgrade(pricing)"
              :loading="loading"
              @selected="handleSelection"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import client from "@/lib/ApiClient"
import PricingCard from "@/components/PricingPage/PricingCard.vue"

export default {
  name: "ChangeDialog",

  props: ["value", "suggesting"],

  components: {
    PricingCard
  },

  data() {
    return {
      loading: false
    }
  },

  computed: {
    ...mapGetters([
      "plans",
      "currentPlan",
      "currentTenant",
      "subscription",
      "subscriptionSchedule"
    ]),
    dialog: {
      get() {
        return this.value
      },

      set(payload) {
        return this.$emit("input", payload)
      }
    },
    filteredPlans() {
      // const result = this.plans.filter(
      //   (p) => p.code !== this.subscription.plan_code
      // )
      if (this.suggesting)
        return this.plans.filter((p) => this.isUpgrade(p) !== "DOWNGRADE")
      return this.plans
    }
  },

  methods: {
    ...mapActions([
      "setSubscription",
      "setSubscriptionSchedule",
      "triggerReload"
    ]),

    handleSelection(plan_code, schedule = false) {
      if (plan_code === this.subscriptionSchedule) this.releaseSchedule()
      else this.changeSubscription(plan_code, schedule)
    },

    async poll() {
      const subscriptionResponse =
        await client.gateway.billing.subscriptionInformation()
      if (subscriptionResponse.activated) {
        // Polling for immediate upgrade, should it ever have schedule?
        if (this.subscription.has_schedule)
          this.setSubscriptionSchedule(
            await client.gateway.billing.subscriptionSchedule()
          )
        this.setSubscription(subscriptionResponse)
        this.triggerReload("quotas")
        this.loading = false
        this.dialog = false
      } else return setTimeout(this.poll, 500)
    },

    async changeSubscription(plan_code, schedule) {
      this.loading = true
      await client.gateway.billing.changeSubscription({
        plan_code,
        schedule
      })
      if (schedule) {
        this.setSubscriptionSchedule(
          await client.gateway.billing.subscriptionSchedule()
        )
        const subscriptionResponse =
          await client.gateway.billing.subscriptionInformation()
        this.setSubscription(subscriptionResponse)
        this.loading = false
        this.dialog = false
      } else this.poll()
    },

    async releaseSchedule() {
      this.loading = true
      await client.gateway.billing.releaseSchedule()
      this.setSubscriptionSchedule(null)
      this.setSubscription({ ...this.subscription, has_schedule: false })
      this.loading = false
      this.dialog = false
    },

    isUpgrade(pricingOrPlan) {
      if (!this.currentPlan) return
      return pricingOrPlan.tier > this.currentPlan.tier
        ? "UPGRADE"
        : pricingOrPlan.tier < this.currentPlan.tier
        ? "DOWNGRADE"
        : "CURRENT"
    }
  }
}
</script>
